/**
 * Portfolio gallery — Masonry layout after images report natural dimensions.
 * Requires masonry.pkgd.min.js + imagesloaded.pkgd.min.js (loaded by section).
 */
(function () {
  function initGrid(grid) {
    if (!grid || typeof Masonry !== 'function') return;

    var msnry = new Masonry(grid, {
      itemSelector: '.portfolio-item',
      columnWidth: '.portfolio-masonry__sizer',
      percentPosition: true,
      gutter: 14,
      transitionDuration: '0.35s',
    });

    function relayout() {
      msnry.layout();
    }

    if (typeof imagesLoaded === 'function') {
      imagesLoaded(grid).on('progress', relayout);
      imagesLoaded(grid).on('always', relayout);
    } else {
      grid.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', relayout, { once: true });
      });
      relayout();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(relayout, 150);
    });
  }

  function boot() {
    document.querySelectorAll('[data-portfolio-masonry]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var grid = evt.target.querySelector('[data-portfolio-masonry]');
    if (grid) initGrid(grid);
  });
})();
